/* Pooja Ragenee theme · pr-nav.js: global nav auto-theme, desktop flyout (hover intent, keyboard), full-screen mobile menu,
   search overlay with Shopify predictive search, footer columns + newsletter check. Port of mockup/v3/apple.js section 5. */
(function (w, d) {
  'use strict';
  var PR = w.PR, $ = PR.$, $$ = PR.$$, esc = PR.esc;
  var navEl, menuEl, flyEl, flyScrim, searchEl, searchScrim;
  var fly = { idx: -1, open: false, tOpen: 0, tClose: 0 };
  function flyOK() { return w.innerWidth >= 834; }
  function lock(on) { d.body.classList.toggle('ap-lock', on); }

  /* Desktop flyout ---------------------------------------------------------------------------------------------- */
  function flyPlace() {
    if (!flyEl || !navEl) return;
    var b = navEl.getBoundingClientRect().bottom;
    if (b <= 0 && fly.open) { flyClose(); return; }
    flyEl.style.top = flyScrim.style.top = Math.max(0, b) + 'px';
  }
  function flyOpen(idx, focusIn) {
    clearTimeout(fly.tOpen); clearTimeout(fly.tClose);
    var tpl = flyEl && $('template[data-pr-fly="' + idx + '"]', flyEl);
    if (!tpl || !flyOK()) { flyClose(); return; }
    if (fly.idx !== idx || !fly.open) {
      $$('.ap-flyout__inner', flyEl).forEach(function (x) { if (x.parentNode === flyEl) flyEl.removeChild(x); });
      flyEl.appendChild(tpl.content.cloneNode(true));
      flyEl.setAttribute('aria-label', tpl.getAttribute('data-label') || '');
      if (fly.open) { flyEl.classList.remove('is-swap'); void flyEl.offsetWidth; flyEl.classList.add('is-swap'); }
      PR.images.scan(flyEl);
    }
    fly.idx = idx; fly.open = true;
    var th = navEl.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
    flyEl.setAttribute('data-theme', th); flyScrim.setAttribute('data-theme', th);
    flyPlace();
    flyEl.classList.add('is-open'); flyEl.inert = false; flyScrim.classList.add('is-open'); navEl.classList.add('is-flyout');
    $$('[data-peek]', navEl).forEach(function (b) { b.setAttribute('aria-expanded', String(+b.getAttribute('data-peek') === idx)); });
    $$('.ap-nav__link', navEl).forEach(function (a) { a.classList.toggle('is-hot', +a.getAttribute('data-nav') === idx); });
    if (focusIn) setTimeout(function () { var f = $('a[href], button', flyEl); if (f) f.focus(); }, 40);
  }
  function flyClose(returnFocus) {
    clearTimeout(fly.tOpen); clearTimeout(fly.tClose);
    if (!flyEl || !fly.open) return;
    var idx = fly.idx; fly.open = false;
    flyEl.classList.remove('is-open', 'is-swap'); flyEl.inert = true; flyScrim.classList.remove('is-open'); navEl.classList.remove('is-flyout');
    $$('[data-peek]', navEl).forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    $$('.ap-nav__link', navEl).forEach(function (a) { a.classList.remove('is-hot'); });
    if (returnFocus) { var a = $('[data-nav="' + idx + '"]', navEl); if (a) a.focus(); }
  }
  function flyLater() { clearTimeout(fly.tOpen); clearTimeout(fly.tClose); fly.tClose = setTimeout(function () { flyClose(); }, 220); }
  PR.flyout = { open: function (i) { flyOpen(typeof i === 'number' ? i : 0); }, close: function () { flyClose(); } };

  /* Mobile menu ------------------------------------------------------------------------------------------------- */
  function setMenu(on) {
    if (!menuEl) return;
    if (on) { flyClose(); if (PR.search) PR.search.close(false); if (PR.bag && PR.bag.close) PR.bag.close(); }
    if (!on && menuEl.classList.contains('is-sub')) menuBack(true);
    menuEl.classList.toggle('is-open', on); menuEl.inert = !on; navEl.classList.toggle('is-open', on);
    /* auto-theme pages: the menu takes the nav's current theme (dark over a black section) until it closes */
    if (navEl.hasAttribute('data-auto-theme')) {
      if (on) { if (!menuEl.hasAttribute('data-pr-fixed-theme')) menuEl.setAttribute('data-theme', navEl.getAttribute('data-theme') || 'light'); }
      else if (!menuEl.hasAttribute('data-pr-fixed-theme')) menuEl.removeAttribute('data-theme');
    }
    var b = $('.ap-burger', navEl);
    if (b) { b.setAttribute('aria-expanded', String(on)); b.setAttribute('aria-label', on ? PR.t('general.close_menu') || 'Close menu' : PR.t('general.menu') || 'Menu'); }
    lock(on);
    PR.scroll.kick();
  }
  function menuSub(i) {
    var tpl = $('template[data-pr-sub="' + i + '"]', menuEl), sub = $('.ap-menu__pane--sub', menuEl), rootP = $('.ap-menu__pane--root', menuEl);
    if (!tpl || !sub) return;
    sub.innerHTML = ''; sub.appendChild(tpl.content.cloneNode(true)); PR.images.scan(sub);
    menuEl.classList.add('is-sub'); menuEl.setAttribute('data-sub-open', i);
    sub.inert = false; rootP.inert = true; sub.scrollTop = 0;
    $$('[data-sub]', menuEl).forEach(function (b) { b.setAttribute('aria-expanded', String(b.getAttribute('data-sub') === String(i))); });
    setTimeout(function () { var bk = $('[data-menu-back]', sub); if (bk) bk.focus({ preventScroll: true }); }, 60);
  }
  function menuBack(silent) {
    var sub = $('.ap-menu__pane--sub', menuEl), rootP = $('.ap-menu__pane--root', menuEl), i = menuEl.getAttribute('data-sub-open');
    menuEl.classList.remove('is-sub'); sub.inert = true; rootP.inert = false;
    $$('[data-sub]', menuEl).forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    var b = i != null && $('[data-sub="' + i + '"]', menuEl); if (b && !silent) setTimeout(function () { b.focus({ preventScroll: true }); }, 60);
  }
  PR.menu = {
    open: function () { setMenu(true); },
    close: function () { if (menuEl && menuEl.classList.contains('is-open')) setMenu(false); },
    sub: function (i) { setMenu(true); menuSub(i); }, back: function () { menuBack(); }
  };

  /* Nav theme: index auto-themes over [data-ap-dark]; story is dark; else light ---------------------------------- */
  PR.nav = {
    setTheme: function (t) {
      if (!navEl) return;
      if (t) { navEl.setAttribute('data-theme', t); navEl._prForced = true; } else { navEl._prForced = false; navEl._prDark = null; PR.scroll.kick(); }
    }
  };
  function autoTheme() {
    if (!navEl || !navEl.hasAttribute('data-auto-theme') || navEl._prForced) return;
    if (navEl.classList.contains('is-open')) return;   /* menu open: keep the theme it opened with (mockup: dark over the hero) */
    var dark = PR.darkAt(navEl.getBoundingClientRect().bottom + 1, navEl);
    if (navEl._prDark === dark) return;
    navEl._prDark = dark; navEl.setAttribute('data-theme', dark ? 'dark' : 'light');
    var m = d.querySelector('meta[name="theme-color"]'); if (m) m.setAttribute('content', dark ? '#000000' : '#ffffff');
    if (fly.open) { flyEl.setAttribute('data-theme', dark ? 'dark' : 'light'); flyScrim.setAttribute('data-theme', dark ? 'dark' : 'light'); }
  }

  function wireNav(el) {
    navEl = el;
    var wrap = el.parentNode;
    menuEl = $('#ap-menu', wrap) || $('#ap-menu'); flyEl = $('#ap-flyout', wrap) || $('#ap-flyout'); flyScrim = $('.ap-flyout-scrim', wrap) || $('.ap-flyout-scrim');
    fly.idx = -1; fly.open = false;
    var fine = w.matchMedia ? w.matchMedia('(hover: hover) and (pointer: fine)') : { matches: true };
    $$('.ap-nav__item', el).forEach(function (li) {
      li.addEventListener('mouseenter', function () {
        if (!fine.matches || !flyOK()) return;
        clearTimeout(fly.tClose); clearTimeout(fly.tOpen);
        var idx = +$('.ap-nav__link', li).getAttribute('data-nav');
        if (!li.hasAttribute('data-fly')) { flyLater(); return; }
        if (fly.open) flyOpen(idx); else fly.tOpen = setTimeout(function () { flyOpen(idx); }, 120);
      });
    });
    [$('.ap-nav__tools', el), $('.ap-nav__logo', el)].forEach(function (x) { if (x) x.addEventListener('mouseenter', function () { if (fly.open) flyLater(); else clearTimeout(fly.tOpen); }); });
    el.addEventListener('mouseleave', function () { clearTimeout(fly.tOpen); if (fly.open) flyLater(); });
    if (flyEl) {
      flyEl.addEventListener('mouseenter', function () { clearTimeout(fly.tClose); });
      flyEl.addEventListener('mouseleave', flyLater);
      flyEl.addEventListener('click', function (e) { if (e.target.closest('a')) flyClose(); });
      flyEl.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
        var f = $$('a[href], button', flyEl), k = f.indexOf(d.activeElement); if (k < 0) return;
        e.preventDefault(); f[(k + (e.key === 'ArrowDown' ? 1 : -1) + f.length) % f.length].focus();
      });
      flyEl.addEventListener('focusout', function (e) { if (fly.open && e.relatedTarget && outside(e.relatedTarget)) flyClose(); });
    }
    if (flyScrim) { flyScrim.addEventListener('mouseenter', flyLater); flyScrim.addEventListener('click', function () { flyClose(); }); }
    function outside(t) { return !t || !(el.contains(t) || (flyEl && flyEl.contains(t))); }
    el.addEventListener('focusin', function (e) {
      var a = e.target.closest('.ap-nav__link');
      var vis = false; try { vis = a && a.matches(':focus-visible'); } catch (er) {}
      if (a && a.parentNode.hasAttribute('data-fly') && vis) flyOpen(+a.getAttribute('data-nav'));
      else if (!e.target.closest('.ap-nav__item[data-fly]')) flyClose();
    });
    el.addEventListener('focusout', function (e) { if (fly.open && e.relatedTarget && outside(e.relatedTarget)) flyClose(); });
    el.addEventListener('keydown', function (e) {
      var a = e.target.closest('.ap-nav__link');
      if (a && e.key === 'ArrowDown' && a.parentNode.hasAttribute('data-fly')) { e.preventDefault(); flyOpen(+a.getAttribute('data-nav'), true); }
    });
    $$('[data-peek]', el).forEach(function (b) {
      b.addEventListener('click', function () {
        var i = +b.getAttribute('data-peek');
        if (fly.open && fly.idx === i && flyEl.contains(d.activeElement)) flyClose(true); else flyOpen(i, true);
      });
    });
    if (menuEl) menuEl.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-sub]'); if (b) { menuSub(b.getAttribute('data-sub')); return; }
      if (e.target.closest('[data-menu-back]')) { menuBack(); return; }
      if (e.target.closest('a[href]') && !e.target.closest('[data-ap-size-open]')) setMenu(false);
    });
    navEl._prDark = null; autoTheme();
  }

  /* Search overlay + predictive search -------------------------------------------------------------------------- */
  var sLast = null, sCtl = null, sT = 0;
  function sInput() { return $('#ap-search-q', searchEl); }
  function sUrl(q) { return PR.cfg.routes.search + '?q=' + encodeURIComponent(q) + '&type=product'; }
  function pill(label, href) { return '<li><a class="ap-pill" href="' + esc(href) + '">' + esc(label) + '</a></li>'; }
  function sRender(q) {
    var box = $('#ap-search-res', searchEl), st = $('#ap-search-status', searchEl);
    q = String(q || '').trim();
    if (sCtl) { try { sCtl.abort(); } catch (e) {} sCtl = null; }
    if (!q) {
      var pop = PR.cfg.popular || [];
      box.innerHTML = pop.length ? '<div class="ap-search__sec"><h2 class="ap-search__h">' + esc(PR.t('general.popular')) + '</h2><ul class="ap-pills" role="list">' +
        pop.map(function (p) { return pill(p.label, p.url); }).join('') + '</ul></div>' : '';
      var qt = $('template[data-pr-search-quick]', searchEl);
      if (qt) box.insertAdjacentHTML('beforeend', qt.innerHTML);
      st.textContent = ''; return;
    }
    var url = PR.cfg.routes.suggest + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
    sCtl = 'AbortController' in w ? new AbortController() : null;
    fetch(url, { headers: { Accept: 'application/json' }, signal: sCtl ? sCtl.signal : undefined })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (j) {
        var list = (j && j.resources && j.resources.results && j.resources.results.products) || [];
        var html = '';
        if (list.length) {
          html = '<div class="ap-search__sec"><h2 class="ap-search__h">' + esc(PR.t('general.products')) + '</h2><ul class="ap-search__list" role="list">' + list.map(function (p) {
            var min = Math.round(parseFloat(p.price_min || p.price) * 100), max = Math.round(parseFloat(p.price_max || p.price) * 100);
            var price = PR.money(min); if (max > min) price = PR.t('product.from', { price: price }) || price;
            var cat = (w.PR_DATA && PR_DATA.cats && PR_DATA.cats[p.handle]) || 'bra';
            var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
            var src = img ? img + (img.indexOf('?') >= 0 ? '&' : '?') + 'width=120' : '';
            var meta = [p.type].filter(Boolean).join(' · ') + (p.available === false ? ' · ' + PR.t('product.sold_out') : '');
            return '<li><a class="ap-sresult" href="' + esc(p.url) + '"><div class="ap-media" data-cat="' + esc(cat) + '">' +
              (src ? '<img class="ap-media__img" src="' + esc(src) + '" alt="" width="120" height="150" loading="eager" decoding="async">' : '') + '</div>' +
              '<span class="ap-sresult__txt"><span class="ap-sresult__name">' + esc(PR.name(p.handle, p.title)) + '</span><span class="ap-sresult__meta">' + esc(meta) + '</span></span>' +
              '<span class="ap-sresult__price">' + esc(price) + '</span></a></li>';
          }).join('') + '</ul><p class="ap-search__more"><a class="ap-link" href="' + esc(sUrl(q)) + '">' + esc(PR.t('general.see_all_results', { terms: q })) + '</a></p></div>';
          st.textContent = PR.t('collection.results', { count: list.length });
        } else {
          html = '<div class="ap-search__none"><p>' + esc(PR.t('general.no_results', { terms: q })) + '</p></div>';
          st.textContent = PR.t('general.no_results', { terms: q });
        }
        box.innerHTML = html; PR.images.scan(box);
      })
      .catch(function (e) { if (e && e.name === 'AbortError') return; box.innerHTML = '<p class="ap-search__more"><a class="ap-link" href="' + esc(sUrl(q)) + '">' + esc(PR.t('general.see_all_results', { terms: q })) + '</a></p>'; });
  }
  PR.search = {
    open: function (q) {
      if (!searchEl) return;
      flyClose(); PR.menu.close(); if (PR.bag && PR.bag.close) PR.bag.close();
      if (!searchEl.classList.contains('is-open')) sLast = d.activeElement;
      var input = sInput();
      if (typeof q === 'string') input.value = q;
      $('[data-s-clear]', searchEl).hidden = !input.value;
      sRender(input.value);
      searchEl.style.top = searchScrim.style.top = navEl ? Math.max(0, navEl.getBoundingClientRect().bottom) + 'px' : '0px';
      searchEl.inert = false; searchEl.classList.add('is-open'); searchScrim.classList.add('is-open'); lock(true);
      if (navEl) { navEl.classList.add('is-searching'); var b = $('.ap-nav__tools [data-ap-search-open]', navEl); if (b) b.setAttribute('aria-expanded', 'true'); }
      input.focus({ preventScroll: true });
      return searchEl;
    },
    close: function (returnFocus) {
      if (!searchEl || !searchEl.classList.contains('is-open')) return;
      searchEl.classList.remove('is-open'); searchScrim.classList.remove('is-open'); searchEl.inert = true; lock(false);
      if (navEl) { navEl.classList.remove('is-searching'); var b = $('.ap-nav__tools [data-ap-search-open]', navEl); if (b) b.setAttribute('aria-expanded', 'false'); }
      if (returnFocus !== false && sLast && sLast.focus && d.contains(sLast)) sLast.focus({ preventScroll: true });
    }
  };
  function wireSearch() {
    searchEl = $('[data-pr-search]'); searchScrim = $('[data-pr-search-scrim]');
    if (!searchEl) return;
    var input = sInput();
    input.addEventListener('input', function () { clearTimeout(sT); sT = setTimeout(function () { sRender(input.value); }, 150); $('[data-s-clear]', searchEl).hidden = !input.value; });
    $('form', searchEl).addEventListener('submit', function (e) { if (!input.value.trim()) e.preventDefault(); });
    $('[data-s-clear]', searchEl).addEventListener('click', function () { input.value = ''; sRender(''); this.hidden = true; input.focus(); });
    $('[data-s-cancel]', searchEl).addEventListener('click', function () { PR.search.close(true); });
    if (searchScrim) searchScrim.addEventListener('click', function () { PR.search.close(); });
    searchEl.addEventListener('click', function (e) { var a = e.target.closest('a[href]'); if (a && !a.hasAttribute('data-ap-size-open')) PR.search.close(false); });
    searchEl.addEventListener('keydown', function (e) {
      if (e.key === 'Tab') { trapTab(e, searchEl); return; }
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var f = [input].concat($$('.ap-search__res a', searchEl)), k = f.indexOf(d.activeElement); if (k < 0) return;
      e.preventDefault(); f[Math.max(0, Math.min(f.length - 1, k + (e.key === 'ArrowDown' ? 1 : -1)))].focus();
    });
  }
  function trapTab(e, box) {
    var f = $$('a[href],button:not([disabled]),input:not([type="hidden"]),select,textarea,[tabindex]:not([tabindex="-1"])', box).filter(function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    if (e.shiftKey && d.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && d.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  }
  PR.trapTab = trapTab;

  /* Footer: mobile accordion columns + newsletter email check (the real customer form posts to Shopify) ------------ */
  function wireFooter(el) {
    $$('.ap-footer__col button', el).forEach(function (b) {
      if (b._pr) return; b._pr = true;
      b.addEventListener('click', function () { var c = b.closest('.ap-footer__col'), on = !c.classList.contains('is-open'); c.classList.toggle('is-open', on); b.setAttribute('aria-expanded', String(on)); });
    });
    $$('form', el).forEach(function (f) {
      var box = $('.ap-news', f); if (!box || f._pr) return; f._pr = true;
      f.addEventListener('submit', function (e) {
        var inp = $('input[type="email"]', f), msg = $('[data-pr-news-msg]', f), ok = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test((inp.value || '').trim());
        box.classList.toggle('is-error', !ok);
        if (!ok) { e.preventDefault(); if (msg) msg.textContent = PR.t('footer.invalid_email') || 'Enter a valid email address.'; inp.focus(); }
      });
    });
  }

  /* Init -------------------------------------------------------------------------------------------------------- */
  PR.sections.register('pr-header', wireNav, function () { flyClose(); navEl = null; });
  PR.sections.register('pr-footer', wireFooter);
  PR.ready(function () {
    wireSearch();
    PR.scroll.onFrame(autoTheme);
    w.addEventListener('scroll', function () { if (fly.open) flyPlace(); }, { passive: true });
    w.addEventListener('resize', function () { if (w.innerWidth >= 834) { if (menuEl && menuEl.classList.contains('is-open')) setMenu(false); } else flyClose(); });
    d.addEventListener('click', function (e) {
      var t = e.target.closest('[data-ap-search-open],[data-ap-menu-open]'); if (!t) return;
      e.preventDefault();
      if (t.hasAttribute('data-ap-menu-open')) { setMenu(!(menuEl && menuEl.classList.contains('is-open'))); return; }
      if (searchEl && searchEl.classList.contains('is-open') && t.closest('.ap-nav__tools')) PR.search.close(); else PR.search.open();
    });
    d.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (searchEl && searchEl.classList.contains('is-open')) { PR.search.close(true); return; }
        if (fly.open) { flyClose((flyEl && flyEl.contains(d.activeElement)) || (navEl && navEl.contains(d.activeElement))); return; }
        if (menuEl && menuEl.classList.contains('is-open')) { if (menuEl.classList.contains('is-sub')) { menuBack(); return; } setMenu(false); var b = navEl && $('.ap-burger', navEl); if (b) b.focus(); }
        return;
      }
      if (e.key === '/' && !e.metaKey && !e.ctrlKey && !e.altKey) {
        var t = e.target, tag = (t && t.tagName) || '';
        if (/^(INPUT|TEXTAREA|SELECT)$/.test(tag) || (t && t.isContentEditable) || d.querySelector('dialog[open]')) return;
        e.preventDefault(); PR.search.open();
      }
    });
  });
})(window, document);